import type { ReactNode } from "react";
import { useBranding, DEFAULT_BRANDING } from "@/lib/branding";

export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  const branding = useBranding();
  const appName = branding?.app_name || DEFAULT_BRANDING.app_name;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-2">
          {branding?.logo_url ? (
            <img src={branding.logo_url} alt={appName} className="h-10 w-10 rounded-xl object-contain" />
          ) : (
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-600 text-lg font-bold text-white">
              {appName.trim()[0]?.toUpperCase() ?? "W"}
            </div>
          )}
          <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">{children}</div>
      </div>
    </div>
  );
}
